import { Container, ContainerItem } from '../common/container/Container'
import { PendingRegistrationService } from '../modules/users/services/PendingRegistrationService'
import { PendingRegistrationApi } from '../modules/users/api/PendingRegistrationApi'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import {
  USERS_MODULE,
  PENDING_REGISTRATION_API_KEY,
  PENDING_REGISTRATION_SERVICE_KEY,
} from '../modules/users/container'

export interface PendingRegistrationContainer {
  pendingRegistrationService: PendingRegistrationService
}

type PendingRegistrationProps = {
  parentContainer?: Container
  config?: {
    moduleFullUrl: string
  }
}

let container: Container

function init(p: PendingRegistrationProps) {
  const items = new Map<symbol, ContainerItem>()

  // Register the API
  items.set(
    PENDING_REGISTRATION_API_KEY,
    new ContainerItem({
      instance: new PendingRegistrationApi(),
    })
  )

  // Register the Service with API key dependency
  items.set(
    PENDING_REGISTRATION_SERVICE_KEY,
    new ContainerItem({
      instance: new PendingRegistrationService({
        apiKey: PENDING_REGISTRATION_API_KEY,
      }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getPendingRegistrationContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[USERS_MODULE],
      },
    })
  }

  return container
}

export const createPendingRegistrationContainer = (): PendingRegistrationContainer => {
  const containerInstance = getPendingRegistrationContainer()
  const pendingRegistrationService = containerInstance.get<PendingRegistrationService>(
    PENDING_REGISTRATION_SERVICE_KEY
  )

  return {
    pendingRegistrationService,
  }
}
